(function () {
  class PayLaterMessage extends HTMLElement {
    constructor() {
      super();
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    connectedCallback() {
      document.addEventListener('variant:changed', this.handleVariantChange);

      if (FoxTheme.pubsub?.subscribe && FoxTheme.pubsub?.PUB_SUB_EVENTS?.variantChange) {
        this.variantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          () => requestAnimationFrame(() => this.updateFromSelectedVariant()),
        );
      }
    }

    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.handleVariantChange);
      this.variantChangeUnsubscriber?.();
    }

    handleVariantChange(event) {
      const variant = event.detail?.variant;
      if (!variant) {
        return;
      }

      this.updateText(variant.price, variant);
    }

    updateFromSelectedVariant() {
      const sectionId = this.dataset.section;
      if (!sectionId) {
        return;
      }

      const variantData = document.querySelector(
        `#variant-selects-${sectionId} [data-selected-variant], #variant-radios-${sectionId} [data-selected-variant]`,
      );

      if (!variantData?.textContent) {
        return;
      }

      try {
        const variant = JSON.parse(variantData.textContent);
        this.updateText(variant.price, variant);
      } catch (error) {
        console.error('PayLaterMessage: Failed to parse variant JSON', error);
      }
    }

    getDisplayPriceCents(baseCents, variant) {
      const baseCentsNum = Number(baseCents);
      if (Number.isNaN(baseCentsNum)) {
        return 0;
      }

      const taxable = variant?.taxable !== false && this.dataset.vatTaxable !== 'false';
      if (this.dataset.vatEnabled !== 'true' || !taxable) {
        return baseCentsNum;
      }

      const vatRate = (Number(this.dataset.vatRate) || 0) / 100;
      if (vatRate <= 0) {
        return baseCentsNum;
      }

      return Math.round(baseCentsNum + baseCentsNum * vatRate);
    }

    formatInstallmentMoney(installmentCents) {
      return FoxTheme.Currency.formatMoney(installmentCents, FoxTheme.settings.moneyFormat);
    }

    updateText(baseCents, variant) {
      const textElement = this.querySelector('[data-pay-later-text]');
      const messageTemplate = this.dataset.messageTemplate;

      if (!textElement || !messageTemplate) {
        return;
      }

      const priceDivider = Number(this.dataset.priceDivider) || 1;
      const displayPriceCents = this.getDisplayPriceCents(baseCents, variant);
      const installmentCents = Math.round(displayPriceCents / priceDivider);
      const installmentMoney = this.formatInstallmentMoney(installmentCents);

      textElement.textContent = messageTemplate
        .replace(/\[price\]/g, installmentMoney)
        .replace(/\{\{\s*price\s*\}\}/g, installmentMoney);
    }
  }

  if (!customElements.get('pay-later-message')) {
    customElements.define('pay-later-message', PayLaterMessage);
  }
})();
